import React from 'react';
import { MapPin, Clock, Video, Calendar as CalendarIcon, ArrowRight } from 'lucide-react';
export function EventsCalendar() {
  const events = [{
    title: 'Board Meeting',
    date: '12',
    month: 'JUN',
    fullDate: 'June 12, 2026',
    time: '6:30 PM',
    location: 'Sylmar Recreation Center',
    isVirtual: true
  }, {
    title: 'Land Use Committee',
    date: '05',
    month: 'JUN',
    fullDate: 'June 5, 2026',
    time: '7:00 PM',
    location: 'Virtual via Zoom',
    isVirtual: true
  }, {
    title: 'Education Committee',
    date: '08',
    month: 'JUN',
    fullDate: 'June 8, 2026',
    time: '6:00 PM',
    location: 'Sylmar Library',
    isVirtual: false
  }, {
    title: 'Public Safety Committee',
    date: '10',
    month: 'JUN',
    fullDate: 'June 10, 2026',
    time: '7:00 PM',
    location: 'Virtual via Zoom',
    isVirtual: true
  }, {
    title: 'Community Movie Night',
    date: '15',
    month: 'JUN',
    fullDate: 'June 15, 2026',
    time: '7:30 PM',
    location: 'Sylmar Park',
    isVirtual: false
  }];
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <div className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2" data-id="element-72">
            Calendario de Eventos
          </h2>
          <p className="text-xl text-sylmar font-medium" data-id="element-73">Events Calendar</p>
          <div className="w-24 h-1 bg-warm mx-auto rounded-full mt-6" data-id="element-74"></div>
        </div>

        <div className="flex flex-col gap-4" data-id="element-75">
          {events.map((event, index) => <div key={index} className="group flex flex-col md:flex-row gap-6 bg-white p-6 rounded-xl shadow-sm border border-gray-100 border-l-4 border-l-sylmar hover:shadow-md transition-all" data-id="element-76">
              {/* Date Badge */}
              <div className="flex-shrink-0 flex flex-col items-center justify-center bg-sylmar-light text-sylmar rounded-lg w-20 h-20 border border-sylmar/20 group-hover:bg-sylmar group-hover:text-white transition-colors" data-id="element-77">
                <span className="text-sm font-bold uppercase tracking-wider" data-id="element-78">
                  {event.month}
                </span>
                <span className="text-3xl font-black leading-none mt-1" data-id="element-79">
                  {event.date}
                </span>
              </div>

              {/* Event Details */}
              <div className="flex-grow flex flex-col justify-center" data-id="element-80">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-81">
                  <h3 className="text-xl font-bold text-charcoal group-hover:text-sky transition-colors" data-id="element-82">
                    {event.title}
                  </h3>
                  {event.isVirtual && <span className="bg-sky/10 text-sky-dark text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1" data-id="element-83">
                      <Video className="w-3 h-3" data-id="element-84" /> Virtual Option
                    </span>}
                </div>

                <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600" data-id="element-85">
                  <div className="flex items-center gap-1.5" data-id="element-86">
                    <CalendarIcon className="w-4 h-4 text-sylmar" data-id="element-87" />
                    {event.fullDate}
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-88">
                    <Clock className="w-4 h-4 text-sylmar" data-id="element-89" />
                    {event.time}
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-90">
                    <MapPin className="w-4 h-4 text-sylmar" data-id="element-91" />
                    {event.location}
                  </div>
                </div>
              </div>

              {/* Action */}
              <div className="flex items-center md:justify-end mt-4 md:mt-0" data-id="element-92">
                <button className="text-charcoal bg-gray-50 hover:bg-warm hover:text-charcoal px-4 py-2 rounded-lg font-semibold text-sm transition-colors border border-gray-200 hover:border-warm" data-id="element-93">
                  Detalles
                </button>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-94">
          <button className="inline-flex items-center justify-center gap-2 bg-charcoal hover:bg-charcoal-light text-white px-8 py-4 rounded-lg font-semibold transition-colors shadow-lg" data-id="element-95">
            <CalendarIcon className="w-5 h-5" data-id="element-96" />
            Ver calendario completo
          </button>
        </div>
      </div>
    </section>;
}